import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MbonusPopup } from 'widgets/mbonus-content/components/mbonus-popup/mbonus-popup'

import MBonusIcon from 'shared/icons/mbonus-mini.svg'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

interface Props {
  bonus: string | undefined
  isTransparent?: boolean
}

export const MbonusLineBeket = ({ bonus }: Props) => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const onClick = () => {
    openDialog({
      child: <MbonusPopup />,
      isDialog: false,
    })
  }

  if (!parseInt(bonus || '0')) {
    return
  }
  return (
    <div
      className={s.bonuses}
      onClick={onClick}
    >
      <div className={s.text}>
        <p className={clsx(s.bonusDescription, 'regular-14')}>
          {t('beket.cashback_mbonus')}
        </p>

        <AppIcon
          id={AllIcons.INFO}
          width={16}
          height={16}
          className={s.info}
        />
      </div>

      <p className={clsx(s.bonus, 'medium-14')}>
        {priceShow(bonus)}
        <img
          src={MBonusIcon}
          alt=""
          className={s.icon}
        />
      </p>
    </div>
  )
}
